import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  state: string;
}

const StateBadge: React.FC<ComponentProps> = ({ state }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(state) && (
        <Badge filled={false} value={state} highlightedValue={false} label={tr(`StateBadge.label`, `State`)}></Badge>
      )}
    </>
  );
};

export default StateBadge;
